import { Button, ErrorContainer } from 'components';
import { useFormikContext } from 'formik';
import { isAiScribeRecordingStatus, openAiScribeDrawer } from 'store/aiScribe/aiScribeSlice';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { hideNoteModal } from 'store/noteModal/noteModalSlice';
import { notifyUserSuccess } from 'utils/notifications';

import { useNoteFormContext } from '../context/noteFormContext';
import { NoteFormValues, remapValues, removeEmptyFieldsFromObject } from '../utils';

export const AiScribeButton = () => {
  const aiScribe = useAppSelector((state) => state.aiScribe);
  const dispatch = useAppDispatch();
  const {
    clientName,
    prependedClientId,
    clientId,
    note,
    onOpenAiScribeDrawer,
    actions: { resetNote }
  } = useNoteFormContext();
  const formik = useFormikContext<NoteFormValues>();

  const onRecord = () => {
    const shouldShowDraftToast = note?.draft || formik.dirty;

    dispatch(
      openAiScribeDrawer({
        clientId: Number(clientId),
        clientName: clientName,
        prependedClientId: prependedClientId,
        note: removeEmptyFieldsFromObject(remapValues({ values: formik.values }))
      })
    );
    resetNote();
    if (shouldShowDraftToast) {
      notifyUserSuccess(
        "Your draft was moved from the Note space to the History and your AI scribe content will be added when it's ready!",
        { delay: 300 }
      );
    }
    dispatch(hideNoteModal());

    onOpenAiScribeDrawer?.();
  };

  return (
    <>
      <Button
        text="Record"
        theme="primary"
        icon={<span className="material-icons">mic</span>}
        handleOnClick={onRecord}
        type="button"
        disabled={isAiScribeRecordingStatus(aiScribe.status)}
      />
      <ErrorContainer
        errors={formik.errors}
        visible={formik.touched?.note && formik.errors?.note}
        name="test"
      />
    </>
  );
};
